import React from 'react'

import { ApplicationSetting as ApplicationSettingContainer } from '@/containers/ApplicationSetting'

export const ApplicationSettings = () => {
    return <ApplicationSettingContainer />
}
